import React from 'react';
import { useLiveData } from '../../live/LiveDataProvider';
import ErrorMessage from '../ErrorMessage';
import Standings from '../Standings';

export default function LiveStandings(props) {
    const liveData = useLiveData();
    const data = props.data;

    const uniqueId = `${data.sportRef}_${data.categoryRef}_${data.tournamentRef}`;
    const tournament = liveData.tournamentByUniqueId[uniqueId];
    
    if (tournament == null) {
        return <ErrorMessage />
    }

    return (
        <Standings seasonId={tournament.seasonId} sportId={tournament.sportRef} />
    );
}
